import Association from "@/models/api/association/Association";
import AssociationRegistrationRequest from "@/models/api/association/AssociationRegistrationRequest";
import axios, { AxiosResponse } from "axios";
import SelectListItem from '../models/SelectListItem';

class Service {
    public async EditAssociation(association: Association): Promise<AxiosResponse<any>> {
        return axios.post("api/association/EditAssociation", association);
    }

    public async GetAssociations(): Promise<AxiosResponse<Association[]>> {
        return axios.get('api/association/GetAssociations/');
    }

    public async GetAssociation(id: number): Promise<AxiosResponse<Association>> {
        return axios.get(`api/association/GetAssociation?id=${id}`);
    }

    public async GetCurrentAssociation(): Promise<AxiosResponse<Association>> {
        return axios.get('api/association/GetCurrentAssociation/');
    }

    public async GetAssociationSelectListItems(searchText?: string): Promise<AxiosResponse<SelectListItem[]>> {
        if (searchText) {
            return axios.get(`api/association/GetAssociationSelectListItems/?searchText=${searchText}`);
        }

        return axios.get('api/association/GetAssociationSelectListItems/');
    }

    public async CanRegisterAssociation(): Promise<AxiosResponse<any>> {
        return axios.get(`api/association/CanRegisterAssociation`);
    }
    public async RegisterAssociation(associationData: AssociationRegistrationRequest): Promise<AxiosResponse<any>> {
        return axios.post("api/association/RegisterAssociation", associationData);
    }

    public async RemoveAssociation(id: number): Promise<AxiosResponse<any>> {
        return axios.delete(`api/association/RemoveAssociation?id=${id}`);
    }



}

export const AssociationService: Service = new Service();
